import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
    selector: 'cr-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.scss'],
    encapsulation: ViewEncapsulation.None
})
export class datepickerComponent {
    @Input() _disabled : boolean = false;
    @Input() _fechaISO : string;
    @Input() _required: boolean = false;
    @Output() GetDate = new EventEmitter<any>();
    public _fcDate : FormControl = new FormControl();
    constructor() { }

    ngOnInit(): void {
        // if(this._fechaISO=="") this._fechaISO = new Date().toISOString().slice(0,10)+"T00:00:00";
    }
    ngAfterViewInit(): void {
        this._fcDate = new FormControl(this._fechaISO);
    }
    _addDate(event: MatDatepickerInputEvent<Date>) {
        if (!event.value) return;
        this._fechaISO = event.value.toISOString().slice(0,10)+"T00:00:00";
        this.GetDate.emit(this._fechaISO);
    }
}

